var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBbps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88 459.673V41H255.633C286.434 41 312.124 45.5656 332.703 54.6968C353.282 63.8281 368.751 76.5027 379.109 92.7209C389.467 108.803 394.646 127.338 394.646 148.326C394.646 164.68 391.375 179.059 384.833 191.461C378.291 203.727 369.296 213.812 357.848 221.716C346.536 229.485 333.589 235.004 319.006 238.275V242.364C334.952 243.045 349.875 247.543 363.777 255.856C377.814 264.17 389.194 275.822 397.916 290.814C406.639 305.669 411 323.386 411 343.966C411 366.181 405.48 386.01 394.441 403.455C383.538 420.763 367.388 434.46 345.991 444.546C324.594 454.631 298.223 459.673 266.877 459.673H88ZM176.518 387.305H248.682C273.35 387.305 291.34 382.603 302.652 373.199C313.964 363.659 319.62 350.985 319.62 335.175C319.62 323.591 316.826 313.369 311.238 304.511C305.65 295.652 297.677 288.701 287.32 283.659C277.098 278.616 264.9 276.095 250.727 276.095H176.518V387.305ZM176.518 216.197H242.14C254.27 216.197 265.037 214.084 274.44 209.859C283.981 205.498 291.476 199.365 296.928 191.461C302.516 183.556 305.309 174.084 305.309 163.045C305.309 147.917 299.926 135.719 289.159 126.452C278.529 117.184 263.401 112.551 243.776 112.551H176.518V216.197Z",
    fill: "#F0FFF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbps);
export default __webpack_public_path__ + "static/media/bbps.0f2e86c18f6de79a80cd624aedf85392.svg";
export { ForwardRef as ReactComponent };